import useSWRMutation from 'swr/mutation';
import { DUpdateSelfMedicationLastSeen } from '../data/dtos/last-seen';
import { selfMedicationChatService } from '../services/self-medication';

export function useUpdateSelfMedicationUserLastSeen({
  userId,
}: Nullable<DUpdateSelfMedicationLastSeen>) {
  const execute = async () => {
    return await selfMedicationChatService.updateLastSeen({
      userId: userId!,
    });
  };

  const fetchKey = userId
    ? ['update-self-medication-user-last-seen', userId]
    : null;
  const { isMutating, trigger } = useSWRMutation(fetchKey, execute);

  return {
    trigger,
    isLoading: isMutating,
  };
}
